import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { Box, CircularProgress, IconButton, Typography } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import axios from 'axios'
import ServiceSidebar from './ServiceSidebar'
import ServiceDetail from './ServiceDetail'

const EstimatingCockpit = (props) => {
  const { projectId } = useParams()
  const history = useHistory()
  const { url } = props

  const [project, setProject] = useState(null)
  const [projectServices, setProjectServices] = useState([])
  const [services, setServices] = useState([])
  const [selectedServiceId, setSelectedServiceId] = useState(null)
  const [loading, setLoading] = useState(true)

  // silent=true skips the loading spinner (for background refreshes after user actions)
  const fetchData = useCallback(async (silent) => {
    try {
      if (!silent) setLoading(true)
      const [projRes, psRes, svcRes] = await Promise.all([
        axios.get(`${url}/api/bid-estimation/projects/${projectId}`),
        axios.get(`${url}/api/bid-estimation/projects/${projectId}/project-services`),
        axios.get(`${url}/api/bid-estimation/services`)
      ])
      setProject(projRes.data)
      setProjectServices(Array.isArray(psRes.data) ? psRes.data : [])
      setServices(Array.isArray(svcRes.data) ? svcRes.data : [])
    } catch (err) {
      console.error('EstimatingCockpit fetch error:', err)
    } finally {
      setLoading(false)
    }
  }, [url, projectId])

  useEffect(() => { fetchData(false) }, [fetchData])

  const refreshSilent = () => fetchData(true)
  const handleServiceAdded = () => refreshSilent()
  const handleServiceRemoved = () => {
    setSelectedServiceId(null)
    refreshSilent()
  }
  const handleServiceUpdated = () => refreshSilent()

  const selectedService = projectServices.find(ps => ps._id === selectedServiceId)

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box style={{ display: 'flex', height: 'calc(100vh - 64px)', overflow: 'hidden' }}>
      <ServiceSidebar
        projectServices={projectServices}
        services={services}
        selectedServiceId={selectedServiceId}
        onSelectService={setSelectedServiceId}
        onServiceAdded={handleServiceAdded}
        onServiceRemoved={handleServiceRemoved}
        projectId={projectId}
        url={url}
      />
      <Box style={{ flex: 1, overflow: 'auto', padding: 20, backgroundColor: '#fafafa' }}>
        {/* Header */}
        <Box display="flex" alignItems="center" mb={2}>
          <IconButton size="small" onClick={() => history.push(`/bid-estimation/${projectId}`)}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" style={{ marginLeft: 8 }}>
            Estimating — {project ? project.name : ''}
          </Typography>
        </Box>

        {selectedService ? (
          <ServiceDetail
            projectService={selectedService}
            project={project}
            url={url}
            onUpdate={handleServiceUpdated}
          />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
            <Typography color="textSecondary">
              Select a service from the sidebar to start estimating.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user
})

export default connect(mapStateToProps)(EstimatingCockpit)
